import type {
  MultipleAvailableOpportunity,
  MultipleOpportunity,
  SingleAvailableOpportunity,
  SingleMinOddsRestrictedOpportunity,
  SingleOpportunity
} from '@ps/isp-web-services-types';

import {
  getIsAvailableOpportunity,
  getIsMultipleOpportunity,
  getIsRestrictedMinOddsOpportunity,
  getIsSingleOpportunity
} from './getIsOpportunity';

export const getAvailableSingleOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): SingleAvailableOpportunity[] =>
  opportunities.filter(
    (opportunity: SingleOpportunity | MultipleOpportunity) =>
      getIsSingleOpportunity(opportunity) && getIsAvailableOpportunity(opportunity)
  ) as SingleAvailableOpportunity[];

export const getMinOddsRestrictedSingleOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): SingleMinOddsRestrictedOpportunity[] =>
  opportunities.filter(
    (opportunity: SingleOpportunity | MultipleOpportunity) =>
      getIsSingleOpportunity(opportunity) && getIsRestrictedMinOddsOpportunity(opportunity)
  ) as SingleMinOddsRestrictedOpportunity[];

export const getAvailableMultipleOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): MultipleAvailableOpportunity[] =>
  opportunities.filter(
    (opportunity: SingleOpportunity | MultipleOpportunity) =>
      getIsMultipleOpportunity(opportunity) && getIsAvailableOpportunity(opportunity)
  ) as MultipleAvailableOpportunity[];

export const getAvailableOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): (SingleAvailableOpportunity | MultipleAvailableOpportunity)[] =>
  opportunities.filter((opportunity: SingleOpportunity | MultipleOpportunity) =>
    getIsAvailableOpportunity(opportunity)
  ) as (SingleAvailableOpportunity | MultipleAvailableOpportunity)[];
